export interface IFooterProps {
    version: string;
    build: string;
    environment: string;
    enterprise: string;
    className?: string;
}

export const Footer = (props: IFooterProps) => {
    return (
        <div className={props.className}>
            <div>Version: {props.version}</div>
            <div>Build: {props.build}</div>
            <div>Environment: {props.environment}</div>
            <div>Enterprise: {props.enterprise}</div>
        </div>
    );
};
